import React from "react"
import autobind from "class-autobind"
import moment from "moment"
import { lightBlue50, blue800, lightBlue300 } from "material-ui/styles/colors"
import { CircularProgress } from "material-ui"
import { ETimeoffStatus, ITimeoffNote } from "../../models"
import strings from "../../localization/strings"
import ConfirmDialog from "../../components/common/ConfirmDialog"
interface IProps {
  note: ITimeoffNote
  showProgress?: boolean
  handleRemove?(note: ITimeoffNote, cb?: () => void): void
  editState: boolean
  handleEdit?(note: ITimeoffNote): void
  handleSetCandidateNoteForPopup?(note: ITimeoffNote): void
  hidePopup?: boolean
}
interface IState {
  showPopup: boolean
  confirmDialogContent: string
  showProgress: boolean
  popupTop: number
  popupRight: number
}

export default class RightNote extends React.Component<IProps, IState> {
  private popupWidth = 80
  private popupHeight = 50
  private popupPaddig = 16
  constructor(props) {
    super(props)
    this.state = {
      showPopup: false,
      confirmDialogContent: "",
      showProgress: false,
      popupTop: 0,
      popupRight: 0
    }
    autobind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.hidePopup) this.setState({ showPopup: false })
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickDocument)
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickDocument)
  }

  handleClickDocument(e) {
    this.props.handleSetCandidateNoteForPopup && this.props.handleSetCandidateNoteForPopup(null)
    this.setState({ showPopup: false })
  }

  handleClickNote(e) {
    if (!this.props.showProgress && e.nativeEvent.button === 2) {
      e.preventDefault()
      this.props.handleSetCandidateNoteForPopup(this.props.note)
      this.setState({
        showPopup: true,
        popupTop: e.clientY,
        popupRight: window.innerWidth - e.clientX - this.popupPaddig - this.popupWidth / 2
      })
    }
  }

  handleConfirm(action, payload) {
    this.setState({ showProgress: true, confirmDialogContent: "" })
    this.props.handleRemove(this.props.note, () => {
      this.setState({ showProgress: false })
    })
  }

  render() {
    return (
      <div style={{ position: "relative" }} id="abn">
        <div style={{ float: "right", display: "table", tableLayout: "fixed", marginBottom: 20, clear: "both", paddingLeft: 85 }}>
          <div style={{ display: "table-cell", verticalAlign: "top", padding: 0, position: "relative" as "relative" }}>
            <div>
              <div style={{ color: blue800, fontSize: 11, textAlign: "right" }}>
                {`${moment(this.props.note.DateTime).local().format("DD/MM/YYYY hh:mm A")} 
                  (${this.props.note.StatusAssociatedWithNote === ETimeoffStatus.Requested ?
                    strings.Requested :
                    (this.props.note.StatusAssociatedWithNote === ETimeoffStatus.Approved ? strings.Approved : strings.Denied)})`
                }
              </div>
              <div
                style={{ position: "relative", backgroundColor: lightBlue50, padding: 10, borderRadius: 10, border: this.props.editState ? "2px solid #4FC3F7" : "none" }}
                onClick={this.handleClickNote} onContextMenu={this.handleClickNote}
              >
                <span
                  style={{
                    width: 8, height: 8, backgroundColor: lightBlue50, position: "absolute", right: -5, top: 16, transform: "rotate(45deg)",
                    borderTop: this.props.editState ? "2px solid #4FC3F7" : "none", borderRight: this.props.editState ? "2px solid #4FC3F7" : "none"
                  }}
                />
                {this.props.note.Note}
                {(this.props.showProgress || this.state.showProgress) &&
                  <CircularProgress size={15} color={lightBlue300} style={{ position: "absolute", right: 5, top: 13 }} />
                }
              </div>
            </div>
          </div>
        </div>
        {this.state.showPopup &&
          <div
            style={{
              position: "fixed", top: this.state.popupTop, right: this.state.popupRight, backgroundColor: "white",
              boxShadow: "0px 2px 10px #999999", padding: this.popupPaddig, width: this.popupWidth, height: this.popupHeight, zIndex: 1000
            }}
          >
            <div style={{ marginBottom: 10 }} onClick={() => this.props.handleEdit(this.props.note)}>{strings.Edit_Note}</div>
            <div onClick={() => this.setState({ confirmDialogContent: strings.Are_you_sure_remove_note })}>{strings.Remove_Note}</div>
          </div>
        }
        {this.state.confirmDialogContent &&
          <ConfirmDialog
            open={true}
            confirmContent={this.state.confirmDialogContent}
            close={() => this.setState({ confirmDialogContent: "" })}
            confirm={this.handleConfirm}
          />
        }
      </div>
    )
  }
}